"use strict";
import { Interface } from "@ethersproject/abi";
import IMulticallExtended from "@uniswap/swap-router-contracts/artifacts/contracts/interfaces/IMulticallExtended.sol/IMulticallExtended.json";
import { Multicall, toHex } from "@uniswap/v3-sdk";
function validateAndParseBytes32(bytes32) {
  if (!bytes32.match(/^0x[0-9a-fA-F]{64}$/)) {
    throw new Error(`${bytes32} is not valid bytes32.`);
  }
  return bytes32.toLowerCase();
}
export class MulticallExtended {
  static {
    this.INTERFACE = new Interface(IMulticallExtended.abi);
  }
  /**
   * Cannot be constructed.
   */
  constructor() {
  }
  static encodeMulticall(calldatas, validation) {
    if (typeof validation === "undefined") {
      return Multicall.encodeMulticall(calldatas);
    }
    if (!Array.isArray(calldatas)) {
      calldatas = [calldatas];
    }
    if (typeof validation === "string" && validation.startsWith("0x")) {
      const previousBlockhash = validateAndParseBytes32(validation);
      return MulticallExtended.INTERFACE.encodeFunctionData("multicall(bytes32,bytes[])", [
        previousBlockhash,
        calldatas
      ]);
    } else {
      const deadline = toHex(validation);
      return MulticallExtended.INTERFACE.encodeFunctionData("multicall(uint256,bytes[])", [deadline, calldatas]);
    }
  }
}
